import React from "react";
import pick from "lodash/pick";
import { selectedPolygonTypes } from "../Common/Constants";
import { Checkbox } from "antd";
import { havePermission } from "../../permissions";
import LAYERS_PERMISSIONS from "../../permissions/Layers.json";
const { TargetedConsumer, PopulationGrids } = selectedPolygonTypes;

const getPopulationGridRange = ({ data }) => {
	let min = Number.MAX_SAFE_INTEGER;
	let max = Number.MIN_SAFE_INTEGER;
	for (let [, obj] of data.entries()) {
		if (obj.population < min) min = obj.population;
		if (obj.population > max) max = obj.population;
	}
	return { min, max };
};

const getTargetedConsumerPolygon = locations => {
	return {
		polygons: locations.map((obj, ind) => {
			const { population: filterData } = obj;
			return {
				id: ind,
				_id: ind,
				coordinates: obj.coordinates,
				style: {
					fillColor: "#FF000077",
					strokeColor: "#000000",
					zindex: 10
				},
				data: {
					filterData,
					key: "population"
				},
				polygonClick: true,
				type: TargetedConsumer
			};
		})
	};
};

const getTargetedConsumerLegend = ({ legendHandler }) => {
	let legends = [];

	if (havePermission(LAYERS_PERMISSIONS.LAYER_GRIDS_POPULATION))
		legends.push(
			<Checkbox checked onClick={() => legendHandler(PopulationGrids)}>
				Targeted Consumer
			</Checkbox>
		);

	return { legends };
};

const getPopulationGridSlider = ({ locations, sliderHandler, type }) => {
	if (!havePermission(LAYERS_PERMISSIONS.LAYER_TRAGETED_CONSUMER_SLIDER)) return null;
	let { min, max } = getPopulationGridRange({ data: locations });

	return {
		min,
		max,
		sliderHandler,
		type
	};
};

const TargetedConsumerDataService = {
	all: ({ locations, legendHandler, sliderHandler, type }) => {
		return {
			...pick(getTargetedConsumerPolygon(locations), ["polygons"]),
			...getTargetedConsumerLegend({ legendHandler }),
			...{ slider: getPopulationGridSlider({ sliderHandler, locations, type }) }
		};
	},
	polygons: ({ locations }) => {
		return pick(getTargetedConsumerPolygon(locations), ["polygons"]);
	}
};

export default TargetedConsumerDataService;
export { getTargetedConsumerPolygon, getTargetedConsumerLegend, getPopulationGridSlider };
